import Cookies from 'universal-cookie';
import { format, toZonedTime } from 'date-fns-tz';
import toneicon from '../assests/images/tone-icon.png';
import { formatDuration, intervalToDuration } from 'date-fns';

const cookies = new Cookies(null, { path: '/' });
export const accessToken = () => {
  const details = getAuthDetails();
  return {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${details.accessToken}`,
      'x-csrf-token': cookies.get('XSRF-TOKEN'),
    },
  };
};

export const getAuthDetails = () => {
  const details = cookies.get('userDetails');
  return details;
};

export const formatTimestamp = (timestamp: string | undefined | null) => {
  // Handle null, undefined, or empty string values
  if (!timestamp) {
    return 'N/A';
  }

  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const zonedDate = toZonedTime(timestamp, userTimezone);
    return format(zonedDate, 'yyyy-MM-dd HH:mm:ss', { timeZone: userTimezone });
  } catch (error) {
    console.warn('Invalid timestamp format:', timestamp, error);
    return 'Invalid Date';
  }
};

export const getProfileImageUrl = (profilePath: string) => {
  const cfBaseUrl = process.env.REACT_APP_CF_STORAGE_BASE_URL;
  if (!profilePath) return toneicon;
  return `${cfBaseUrl}/${process.env.REACT_APP_PROFILE_FOLDER}/${profilePath.replace(/\\/g, '/')}`;
};

export const getDuration = (startTime: string, endTime: string) => {
  const duration = intervalToDuration({ start: startTime, end: endTime });
  return formatDuration(duration);
};
